export const getEdenValleyData = () => ({
  name: "Eden Valley",
  country: "Australie",
  region: "Barossa Valley",
  description: "Eden Valley est une sous-région prestigieuse de la Barossa Valley, réputée pour ses vins blancs élégants et ses Shiraz frais. Son altitude élevée et son climat plus frais créent des conditions idéales pour des vins de grande finesse.",
  type: "subregion",
  mapAreas: [
    { region: "Eden Valley", x: 48, y: 70, color: "#6d2c7a", size: 4 }
  ],
  statistics: {
    totalArea: "2,000 ha",
    production: "0.15 million hectolitres",
    altitude: "400-600m",
    appellations: "Eden Valley GI",
    exportPercentage: "30%"
  },
  characteristics: {
    climate: "Climat frais avec altitude élevée, étés chauds, hivers froids, grandes amplitudes thermiques",
    soil: "Sols granitiques, argileux, excellente drainage",
    viticulture: "Viticulture traditionnelle, vignobles en altitude, rendements limités"
  },
  wineStyles: {
    red: "Shiraz élégants et frais, avec des tanins soyeux et une complexité aromatique",
    white: "Riesling de classe mondiale, Chardonnay aromatiques, Sauvignon Blanc frais",
    rose: "Rosés frais et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "La viticulture dans l'Eden Valley remonte aux années 1840. La sous-région s'est imposée comme l'une des plus prestigieuses d'Australie pour les vins blancs, reconnue pour ses Riesling de classe mondiale.",
  foodPairing: "Cuisine australienne : fruits de mer, poissons, viandes blanches, fromages affinés, cuisine fusion.",
  grapeVarieties: {
    white: ["Riesling", "Chardonnay", "Sauvignon Blanc"],
    red: ["Shiraz", "Cabernet Sauvignon", "Merlot"]
  },
  keyProducers: ["Henschke", "Pewsey Vale", "Yalumba"],
  notableWines: {
    "riesling": "Riesling de classe mondiale, vieillissement exceptionnel",
    "shiraz": "Shiraz élégants et frais",
    "chardonnay": "Chardonnay aromatiques et complexes"
  }
}); 